import script from "./SlideToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./SlideToolbar.vue?vue&type=style&index=0&id=1e17bcc7&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e17bcc7"]])

export default __exports__